import { Locale, TranslationMessages } from '../context/LanguageContext';

import plGlobal from '../messages/pl-PL/global.json';
import plDashboard from '../messages/pl-PL/dashboard.json';
import plTraining from '../messages/pl-PL/training.json';
import plRanking from '../messages/pl-PL/ranking.json';
import plStats from '../messages/pl-PL/stats.json';
import plSettings from '../messages/pl-PL/settings.json';
import plComponents from '../messages/pl-PL/components.json';

import enGlobal from '../messages/en-EN/global.json';
import enDashboard from '../messages/en-EN/dashboard.json';
import enTraining from '../messages/en-EN/training.json';
import enRanking from '../messages/en-EN/ranking.json';
import enStats from '../messages/en-EN/stats.json';
import enSettings from '../messages/en-EN/settings.json';
import enComponents from '../messages/en-EN/components.json';

import deGlobal from '../messages/de-DE/global.json';
import deDashboard from '../messages/de-DE/dashboard.json';
import deTraining from '../messages/de-DE/training.json';
import deRanking from '../messages/de-DE/ranking.json';
import deStats from '../messages/de-DE/stats.json';
import deSettings from '../messages/de-DE/settings.json';
import deComponents from '../messages/de-DE/components.json';

const translations: Record<Locale, TranslationMessages> = {
  'pl-PL': {
    ...plGlobal,
    ...plDashboard,
    ...plTraining,
    ...plRanking,
    ...plStats,
    ...plSettings,
    ...plComponents
  },
  'en-EN': {
    ...enGlobal,
    ...enDashboard,
    ...enTraining,
    ...enRanking,
    ...enStats,
    ...enSettings,
    ...enComponents
  },
  'de-DE': {
    ...deGlobal,
    ...deDashboard,
    ...deTraining,
    ...deRanking,
    ...deStats,
    ...deSettings,
    ...deComponents
  }
};

export const getMessages = (locale: Locale): TranslationMessages => {
  return translations[locale];
}; 